import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from 'react-router-dom';
import logo from '../../assets/brand/logo1.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner container-fluid">
        <div className="footer-row">
          {/* Brand + Description + Social */}
          <div className="footer-col footer-col-brand">
            <Link to="" className="footer-logo-link" aria-label="Bakumia Home">
              <img src={logo} alt="Bakumia Logo" className="footer-logo" />
            </Link>
            <p className="footer-desc">
              Household and kitchenware unique products for modern living
            </p>
            <div className="footer-social">
              {[
                {
                  href: 'https://api.whatsapp.com/send?phone=923459403395',
                  label: 'WhatsApp',
                  icon: 'fa-whatsapp',
                  className: 'whatsapp',
                },
                {
                  href: 'https://www.facebook.com/bakumia.pk',
                  label: 'Facebook',
                  icon: 'fa-facebook-f',
                  className: 'facebook',
                },
                {
                  href: 'https://www.instagram.com/bakumia.pk/',
                  label: 'Instagram',
                  icon: 'fa-instagram',
                  className: 'instagram',
                },
                {
                  href: 'https://twitter.com/BakumiaP',
                  label: 'Twitter',
                  icon: 'fa-twitter',
                  className: 'twitter',
                },
                {
                  href: 'https://www.youtube.com/channel/UClgC42QRT6uQFLofuy1We4g',
                  label: 'YouTube',
                  icon: 'fa-youtube',
                  className: 'youtube',
                },
                {
                  href: 'https://www.linkedin.com/company/bakumia/',
                  label: 'LinkedIn',
                  icon: 'fa-linkedin',
                  className: 'linkedin',
                },
                {
                  href: 'https://www.pinterest.com/bakumia22/',
                  label: 'Pinterest',
                  icon: 'fa-pinterest',
                  className: 'pinterest',
                },
                {
                  href: 'https://www.tiktok.com/@bakumia.pk',
                  label: 'TikTok',
                  icon: 'fa-tiktok',
                  className: 'tiktok',
                },
              ].map(({ href, label, icon, className }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className={`footer-social-link ${className}`}
                >
                  <i className={`fab ${icon}`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col footer-col-links">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-list">
              <li>
                <Link to="/shop" className="footer-link">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="footer-link">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/sitemap" className="footer-link">
                  Sitemap
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Links */}
          <div className="footer-col footer-col-links">
            <h3 className="footer-title">Support</h3>
            <ul className="footer-list">
              <li>
                <Link to="/faqs" className="footer-link">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/return-policy" className="footer-link">
                  Return Policy
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="footer-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="footer-link">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/delete-account" className="footer-link">
                  Delete Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-col footer-col-contact">
            <h3 className="footer-title">Get In Touch</h3>
            <address className="footer-contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>FF1041, Deans Trade Center, Peshawar</span>
            </address>
            <div className="footer-contact-item">
              <i className="fas fa-envelope"></i>
              <a
                href="mailto:support@bakumia.pk"
                className="footer-contact-link"
              >
                support@bakumia.pk
              </a>
            </div>
            <div className="footer-contact-item whatsapp-contact">
              <i className="fab fa-whatsapp"></i>
              <div>
                <p className="contact-text">Have any questions?</p>
                <a
                  href="https://api.whatsapp.com/send?phone=923459403395"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-contact-link whatsapp-number"
                >
                  0345 9403395
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom mb-0 py-3">
        <span>
          &copy; {new Date().getFullYear()} Bakumia. All rights reserved.
          Developed by{' '}
          <a
            href="https://www.devifysolutions.com"
            target="_blank"
            rel="noopener noreferrer"
            className="developer-link"
          >
            Devify Solutions
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
